import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {
  evaluateTimeAccess,
  getDenyAllowPoliciesForResource,
  handleHcp,
  handleIncludes,
  handleLoggedIn,
  handleTicketCondition
} from './utils';

// Extend dayjs with timezone support
dayjs.extend(utc);
dayjs.extend(timezone);

function formatTicketDate(date) {
  return dayjs(date);
}

const evalPolicy = (policy, params) => {
  const { user, resourceId, effect } = params;
  let result = false;
  const evaluatedPermissionsArray = [];
  const accessDenyReasons = [];

  // eslint-disable-next-line no-constant-condition
  if (false) {
    // TODO: if (store.getters['instancesState/getSuperUser'])
    // result = true;
  } else {
    policy.Requirements.forEach((r) => {
      const context = {
        requirement: r,
        accessDenyReasons,
        evaluatedPermissionsArray
      };
      switch (r.PrincipalField) {
        case 'SocietyMemberType':
          handleIncludes({
            userField: user.societyMemberType,
            ...context
          });
          break;
        case 'EventParticipantType':
          handleIncludes({
            userField: user.participantType,
            ...context
          });
          break;
        case 'ParticipantTypeCheck':
          handleIncludes({
            userField: user.participantTypeValid,
            ...context
          });
          break;
        case 'UserCountry':
          handleIncludes({
            userField: user.country,
            ...context
          });
          break;
        case 'TimeAccess': {
          const tz = params.timezone ?? 'Europe/Berlin';
          const now = dayjs().tz(tz);
          const evaluated = evaluateTimeAccess({
            values: r.Values,
            now
          });

          accessDenyReasons.push(r.PrincipalField);
          evaluatedPermissionsArray.push(evaluated);
          break;
        }

        // case 'ExhibitorExclusive':
        //   const symposiaList = store.getters['ILPSymposiaList/list'];
        //   const currentSession = symposiaList.find(
        //     (item) => item.Id === Number(checkId)
        //   );
        //   const { CompanyAccountId } = currentSession;
        //   const { tickets } = user;
        //   const isInvitedByCurrentExhibitor = tickets.some(
        //     (item) => item.CompanyAccountId === CompanyAccountId
        //   );
        //   if (!isInvitedByCurrentExhibitor) {
        //     accessDenyReasons.push(r.PrincipalField);
        //   }
        //   arr.push(isInvitedByCurrentExhibitor);
        //
        //   break;
        case 'EventTicketPaid':
          handleTicketCondition({
            userTickets: user.tickets,
            conditionFn: (ticket) => ticket.IsPayed,
            ...context
          });
          break;
        case 'Hcp':
        case 'UserHcp':
          handleHcp(user, r, accessDenyReasons, evaluatedPermissionsArray);
          break;
        case 'UserLoggedIn':
          handleLoggedIn(user, r, accessDenyReasons, evaluatedPermissionsArray);
          break;
        case 'EventTicketNameValid':
          handleTicketCondition({
            userTickets: user.tickets.filter((ticket) => ticket.IsValid),
            conditionFn: (ticket) => r.Values.includes(ticket.TicketTypeName),
            ...context
          });
          break;
        case 'EventTicketNamePaid':
          handleTicketCondition({
            userTickets: user.tickets.filter((ticket) => ticket.IsPayed),
            conditionFn: (ticket) => r.Values.includes(ticket.TicketTypeName),
            ...context
          });
          break;
        case 'EventTicketNameForComments':
          handleTicketCondition({
            userTickets: user.tickets.filter((ticket) => ticket.IsPayed),
            conditionFn: (ticket) => r.Values.includes(ticket.TicketTypeName),
            ...context
          });
          break;
        case 'EventTicketNameForMessages':
          handleTicketCondition({
            userTickets: user.tickets.filter((ticket) => ticket.IsPayed),
            conditionFn: (ticket) => r.Values.includes(ticket.TicketTypeName),
            ...context
          });
          break;
        case 'EventTicketNetworking':
          handleTicketCondition({
            userTickets: user.tickets.filter((ticket) => ticket.IsPayed),
            conditionFn: (ticket) => r.Values.includes(ticket.TicketTypeName),
            ...context
          });
          break;
        case 'EventTicketNamePaidAndTime':
          handleTicketCondition({
            userTickets: user.tickets.filter(
              (ticket) => ticket.IsPayed && ticket.TicketFrom && ticket.TicketTo
            ),
            conditionFn: (ticket) => {
              const dateNow = dayjs();
              const ticketFrom = formatTicketDate(ticket.TicketFrom);
              const ticketTo = formatTicketDate(ticket.TicketTo);
              return (
                r.Values.includes(ticket.TicketTypeName)
                && dateNow.diff(ticketFrom) >= 0
                && dateNow.diff(ticketTo) <= 0
              );
            },
            ...context
          });
          break;
        case 'VisitorIdIncluded':
          handleTicketCondition({
            userTickets: user.tickets.filter((ticket) => ticket.VisitorId),
            conditionFn: (ticket) => r.Values.includes(ticket.VisitorId),
            ...context
          });
          break;
        default:
          console.warn(`Unhandled PrincipalField: ${r.PrincipalField}`);
          break;
      }
    });
    // console.log(
    //   'evaluatedPermissionsArray for',
    //   policy.Name,
    //   policy.Effect,
    //   policy.ConditionType,
    //   policy.Requirements.map((r) => r.PrincipalField),
    //   evaluatedPermissionsArray
    // );
    switch (policy.ConditionType) {
      case 'All':
        if (!evaluatedPermissionsArray.includes(false)) {
          result = true;
        }
        break;
      case 'Any':
        if (evaluatedPermissionsArray.includes(true)) {
          result = true;
        }
        break;
      default:
        throw new Error(`Unknown policy condition type: ${policy.ConditionType}`);
    }
  }
  // accessDenyReasonsObj[policy.Name] = accessDenyReasons;
  // localStorage.setItem(
  //   'accessDenyReasons',
  //   JSON.stringify(accessDenyReasonsObj)
  // );
  return { result, accessDenyReasons };
};

export const accessControl = (resourceType) => (resourceId, accessMatrix, user) => {
  const renamedMatrix = {
    resources: accessMatrix.policies,
    policies: accessMatrix.policies_groups
  };

  // Check for admin access via ticket type
  if (user?.tickets?.[0]?.TicketTypeName === 'Admin') {
    return { result: true, cause: 'Admin Access' };
  }

  // Check for admin access via URL parameters (preview mode with JWT token)
  const urlParams = new URLSearchParams(window.location.search);
  const isPreviewMode = urlParams.get('preview') === 'true';
  const hasJwtToken = urlParams.get('jwt_token');

  if (isPreviewMode && hasJwtToken) {
    return { result: true, cause: 'Preview Access' };
  }

  const { allow: allowPolicies, deny: denyPolicies } = getDenyAllowPoliciesForResource(
    resourceType,
    resourceId,
    renamedMatrix
  );

  if (denyPolicies.length === 0 && allowPolicies.length === 0) {
    return { result: true, cause: { Name: 'No rules assigned' } };
  }
  if (Array.isArray(denyPolicies) && denyPolicies.length > 0) {
    for (let i = 0, len = denyPolicies.length; i < len; i += 1) {
      const evaluatedPolicy = evalPolicy(denyPolicies[i], {
        resourceId,
        user,
        effect: denyPolicies[i].Effect
      });
      if (evaluatedPolicy?.result) {
        // here we return the PrincipalField as the cause name
        return {
          result: false,
          cause: {
            Name: `${denyPolicies[i].id}_${evaluatedPolicy.accessDenyReasons.join('_')}`
          }
        };
      }
    }
  }

  if (denyPolicies.length > 0 && allowPolicies.length === 0) {
    return { result: true, cause: { Name: 'No allow rules assigned' } };
  }

  if (Array.isArray(allowPolicies) && allowPolicies.length > 0) {
    const accessDenyReasons = [];
    for (let i = 0, len = allowPolicies.length; i < len; i += 1) {
      const evaluatedPolicy = evalPolicy(allowPolicies[i], {
        user,
        resourceId,
        effect: allowPolicies[i].Effect
      });

      if (evaluatedPolicy?.result) {
        // here we return the PrincipalField as the cause name
        return {
          result: true,
          cause: { Name: evaluatedPolicy?.accessDenyReasons.join('_') }
        };
      }
      accessDenyReasons.push(
        `${allowPolicies[i].id}_${evaluatedPolicy.accessDenyReasons.join('_')}`
      );
    }

    // All policies passed
    return {
      result: false,
      cause: {
        Name: 'All allowed policies are false',
        accessDenyReasons
      }
    };
  }

  // We should never reach here, all cases are covered, it is still here just as a safe guard
  return { result: false, cause: { Name: 'General denied' } };
};

export const accessControlSession = accessControl('Session');

export const accessControlPage = accessControl('Page');

export const accessControlUrl = accessControl('Url');

export const accessControlKey = accessControl('Key');
